import { combineReducers } from 'redux';

import commonReducers from '../../common/reducers';
import lastFeaturedPost from './last-featured-post';

export default combineReducers({
  ...commonReducers,
  lastFeaturedPost,
});
